<section class="pb-container pb-help" [ngClass]="dynamicClass"> 
  <div class="pb-grid pb-grid-cols-1 lg:pb-grid-cols-2 lg:pb-gap-x-10 lg:pb-gap-y-6">
      <div class="pb-pt-3">
          <h2 class="pb-text-d-xl-m lg:pb-text-d-xl pb-mb-4 lg:pb-mb-2 pb-font-serif pb-text-color-brand" data-title="true" *scText="rendering.fields?.Title"></h2>
          <div class="pb-text-md-m lg:pb-text-md pb-pb-5 lg:pb-pb-0" *scText="rendering.fields?.Subtitle"></div>
      </div>
      <ng-container *ngIf="links.length>0; else withoutLinks">
        <div class="lg:pb-row-span-2">
          <div class="pb-bubble pb-relative">
            <h3 class="pb-text-d-md-m pb-italic pb-mb-5 pb-font-serif lg:pb-text-d-md" *scText="rendering.fields?.ChatBubbleTitle"></h3>
            <div class="pb-flex pb-flex-col pb-gap-4 text-md-m lg:text-md">
              <ng-container *ngFor="let link of links">
                <a hybridHref hreflang="{{language}}" href="{{link.href}}" target="{{link.target}}" class="pb-text-md-m pb-font-bold pb-flex pb-items-center pb-justify-between pb-underline" >{{link.text}}</a>
              </ng-container>
            </div>
          </div>
        </div>
        <!-- <div class="pb-w-full sm:pb-w-[552px] sm:pb-h-[250px] lg:pb-ml-auto pb-mt-[25px] lg:pb-mt-0" [innerHTML]="svgCode | TrustHtml"></div> -->
        <img class="pb-w-full sm:pb-w-[552px] sm:pb-h-[250px] lg:pb-ml-auto pb-mt-[25px] lg:pb-mt-0 pb-energy-illustration" *ngIf="image?.src" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="image.src" [alt]="image.alt">
      </ng-container>
  </div>
</section>


<ng-template #withoutLinks>
  <ng-container *ngIf="rendering.fields?.RightImage?.value && hasChatty; else NotRight">
    <a href="#Chatty" attr.aria-label="Open contact form" (click)="openChatty($event)" class="lg:pb-row-span-2">
      <ng-container [ngTemplateOutlet]="bubble" ></ng-container>
    </a>
  </ng-container>
  <ng-template #NotRight>
    <a hybridHref hreflang="{{language}}" href="{{rendering.fields?.Link?.value?.href}}" target="{{rendering.fields?.Link?.value?.target}}"  attr.aria-label="{{rendering.fields?.Link?.value?.text}}" class="lg:pb-row-span-2">
      <ng-container [ngTemplateOutlet]="bubble" ></ng-container>
    </a>
  </ng-template>
</ng-template>



<ng-template #bubble>
  <div class="pb-bubble pb-relative pb-flex pb-min-h-[180px]"
    [ngClass]="rendering.fields?.RightImage?.value && hasChatty ? 'pb-bubble-chatty' : ''"
  >
    <div class="lg:pb-w-4/6">  
      <h3 class=" pb-text-d-md-m pb-italic pb-mb-4 pb-font-serif lg:pb-text-d-md" *scText="rendering.fields?.ChatBubbleTitle"></h3>
      <div class="pb-pb-4" *scText="rendering.fields?.ChatBubbleSubtitle"></div>
      <i class=" pb-inline-block pb-pl-1 pb-icon pb-icon-arrow-right pb-text-i-24 hover:pb-no-underline"></i>
    </div>
    <img *ngIf="rendering.fields?.RightImage?.value" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="image.src" [alt]="image.alt" class="!pb-hidden lg:!pb-block pb-absolute pb-bottom-[-2px] pb-right-0 pb-w-[176px] pb-h-[175px]" />
  </div>
  <img *ngIf="rendering.fields?.RightImage?.value" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="image.src" [alt]="image.alt" class="!pb-block lg:!pb-hidden pb-w-[247px]" />
</ng-template>